import React from "react"
import Layout from "../components/layout"
import { Link, graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"

const Process = () => {
  const data = useStaticQuery(graphql`
  query {
    imageOne: file(relativePath: { eq: "media/gallery/img_000.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    imageTwo: file(relativePath: { eq: "media/gallery/img_001.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  imageThree: file(relativePath: { eq: "media/gallery/img_002.png" }) {
    childImageSharp {
      fluid(maxWidth: 1000) {
        ...GatsbyImageSharpFluid
      }
    }
  }
  imageFour: file(relativePath: { eq: "media/gallery/img_003.png" }) {
    childImageSharp {
      fluid(maxWidth: 1000) {
        ...GatsbyImageSharpFluid
      }
    }
  }
  imageFive: file(relativePath: { eq: "media/gallery/img_004.png" }) {
    childImageSharp {
      fluid(maxWidth: 1000) {
        ...GatsbyImageSharpFluid
      }
    }
  }
  imageSix: file(relativePath: { eq: "media/gallery/img_005.png" }) {
    childImageSharp {
      fluid(maxWidth: 1000) {
        ...GatsbyImageSharpFluid
      }
    }
  }
  imageSeven: file(relativePath: { eq: "media/gallery/img_006.png" }) {
    childImageSharp {
      fluid(maxWidth: 1000) {
        ...GatsbyImageSharpFluid
      }
    }
  }
  imageEight: file(relativePath: { eq: "media/gallery/img_007.png" }) {
    childImageSharp {
      fluid(maxWidth: 1000) {
        ...GatsbyImageSharpFluid
      }
    }
  }
  imageNine: file(relativePath: { eq: "media/gallery/img_008.jpg" }) {
    childImageSharp {
      fluid(maxWidth: 1000) {
        ...GatsbyImageSharpFluid
      }
    }
  }
  imageTen: file(relativePath: { eq: "media/gallery/img_009.png" }) {
    childImageSharp {
      fluid(maxWidth: 1000) {
        ...GatsbyImageSharpFluid
      }
    }
  }
  imageEleven: file(relativePath: { eq: "media/gallery/img_010.png" }) {
    childImageSharp {
      fluid(maxWidth: 1000) {
        ...GatsbyImageSharpFluid
      }
    }
  }
  imageTwelve: file(relativePath: { eq: "media/gallery/img_011.png" }) {
    childImageSharp {
      fluid(maxWidth: 1000) {
        ...GatsbyImageSharpFluid
      }
    }
  }
  imageThirteen: file(relativePath: { eq: "media/gallery/img_012.png" }) {
    childImageSharp {
      fluid(maxWidth: 1000) {
        ...GatsbyImageSharpFluid
      }
    }
  }
  imageFourteen: file(relativePath: { eq: "media/gallery/img_013.png" }) {
    childImageSharp {
      fluid(maxWidth: 1000) {
        ...GatsbyImageSharpFluid
      }
    }
  }
 
  }
  `)
  /*console.log(data)*/
  return (
    <Layout>
      <h2>Process</h2>
      <p>
        This page showcases personal as well as pedagogical work that is often experimental and
        exploratory in nature. I devote a lot of my time crafting personal
        creative tools using code as my main media and medium. Some of these
        evolve into larger projects and become in part research as well as
        production tools. Further information, when available, can be found on
        clicking on an image.{" "}
      </p>
      <br></br>

      {/*<Img  fixed={data.image.childImageSharp.fixed}/>*/}

      <div className="art-cards">
        {/*
                {data.images.nodes.map(image => (
                    <Img key = {image.id} fluid = {image.childImageSharp.fluid}/>
                ))}
                */}

      <Link to="typeshade">
      <div className="art-card-container">
          <Img
            className="image-card"
           fluid={data.imageFourteen.childImageSharp.fluid} 
          />
          <div className="overlay-card">
            <div className="text-card">
            <div className="text-card-title">TypeMotion_02</div>
              <p>
              Experiments in kinetic typography{" "}
              </p>
              <div className="text-card-tags">Typography, generative, research</div>
            </div>
          </div>
        </div>
        </Link>

        <a href="https://mapping20.bitbucket.io/">
        <div className="art-card-container">
          <Img
            className="image-card"
            fluid={data.imageThirteen.childImageSharp.fluid} 
          />
          <div className="overlay-card">
            <div className="text-card">
            <div className="text-card-title">Motion Studies</div>
              <p>
              A small collection of motion sketches for teaching purposes.{" "}
              </p>
              <div className="text-card-tags">Motion, teaching, website</div>
            </div>
          </div>
        </div>
</a>

<a href="http://parametric.esac-cambrai.net/">
        <div className="art-card-container">
          <Img
            className="image-card"
            fluid={data.imageTwelve.childImageSharp.fluid} 
          />
          <div className="overlay-card">
            <div className="text-card">
            <div className="text-card-title">Parametrics</div>
              <p>
              Generative typography research project with students{" "}
              </p>
              <div className="text-card-tags">Typography, workshop, teaching, website</div>
            </div>
          </div>
        </div>
</a>
      <a href="https://dpmanual.bitbucket.io/index.html">
        <div className="art-card-container">
          <Img
            className="image-card"
            fluid={data.imageEleven.childImageSharp.fluid} 
          />
          <div className="overlay-card">
            <div className="text-card">
            <div className="text-card-title">Computational Graphic Design</div>
              <p>
              A collection of programs to learn about graphic design & gestalt theory{" "}
              </p>
              <div className="text-card-tags">Teaching, website</div>
            </div>
          </div>
        </div>   
        </a>    

<div className="art-card-container">
          <Img
            className="image-card"
            fluid={data.imageTen.childImageSharp.fluid}
          />
          <div className="overlay-card">
            <div className="text-card">
            <div className="text-card-title">Initials</div>
              <p>
              More information coming soon...;–){" "}
              </p>
              <div className="text-card-tags">Typography, generative, research</div>
            </div>
          </div>
        </div>


<a href="https://designingprograms.bitbucket.io/">
<div className="art-card-container">

          <Img
            className="image-card"
            fluid={data.imageNine.childImageSharp.fluid} 
          />
          <div className="overlay-card">
            <div className="text-card">
              <div className="text-card-title">Designing Programs</div>
              <p>
                A practical introduction to creative programming.{" "}
              </p>
              <div className="text-card-tags">Teaching, P5.js, Processing, website</div>
            </div>
          </div>
        </div>
</a>


<a href="https://samdraws.bitbucket.io/logs/log012.html">
        <div className="art-card-container">
          <Img
            className="image-card"
            fluid={data.imageEight.childImageSharp.fluid}
          />
          <div className="overlay-card">
            <div className="text-card">
              <div className="text-card-title">SAM @Pompidou</div>
              <p>
                An interactive art installation about drawing with the machine.{" "}
              </p>
              <div className="text-card-tags">Installation, art, design</div>
            </div>
          </div>
        </div>
    </a>

<Link to="/dither">
  <div className="art-card-container">
          <Img
            className="image-card"
            fluid={data.imageSeven.childImageSharp.fluid} 
          />
          <div className="overlay-card">
            <div className="text-card">
              <div className="text-card-title">DitherType</div>
              <p>
                Experimental typographic research with custom dithering tools.{" "}
              </p>
              <div className="text-card-tags">Typography, dithering, experimental</div>
            </div>
          </div>
        </div>
        </Link>
    
<a href="https://www.flickr.com/photos/tisane_01/30343654627/in/dateposted-public/">
        <div className="art-card-container">
          <Img
            className="image-card"
            fluid={data.imageSix.childImageSharp.fluid} 
          />
          <div className="overlay-card">
            <div className="text-card">
              <div className="text-card-title">TypeMotion_01</div>
              <p>
                Experimental typographic research.{" "}
              </p>
              <div className="text-card-tags">Print, dithering, experimental</div>
            </div>
          </div>
        </div>
      </a>

        <Link to ="/sam">
        <div className="art-card-container">
          <Img
            className="image-card"
            fluid={data.imageFive.childImageSharp.fluid} 
          />
          <div className="overlay-card">
            <div className="text-card">
              <div className="text-card-title">SAM</div>
              <p>
                The home-made drawing machine called SAM.{" "}
              </p>
              <div className="text-card-tags">Processing, Arduino</div>
            </div>
          </div>
        </div>
      </Link>

      <a href="https://bitbucket.org/mwebster_/dial-a-demo/src/master/">
        <div className="art-card-container">
          <Img
            className="image-card"
            fluid={data.imageFour.childImageSharp.fluid}
          />
          <div className="overlay-card">
            <div className="text-card">
              <div className="text-card-title">Dial A Demo</div>
              <p>
                An interactive installation for presenting student work on generative motion.{" "}
              </p>
              <div className="text-card-tags">Installation, art, design</div>
            </div>
          </div>
        </div>
    </a> 

        <div className="art-card-container">
          <Img
            className="image-card"
            fluid={data.imageThree.childImageSharp.fluid} 
          />
          <div className="overlay-card">
            <div className="text-card">
              <div className="text-card-title">Print++</div>
              <p>
              More information coming soon...;–){" "}
              </p>
            </div>
          </div>
        </div>
        
        <Link to="/alpha">
        <div className="art-card-container">
          <Img
            className="image-card"
            fluid={data.imageTwo.childImageSharp.fluid} 
          />      
            <div className="overlay-card">
              <div className="text-card">
                <div className="text-card-title">AlphaGraph</div>
                <p>
                  A custom-made tool for exploring letter form.{" "}
                </p>
                <div className="text-card-tags">Printing, typography, workshops</div>
              </div>
            </div>     
        </div>
        </Link>

        <Link to ="/polyarch">
        <div className="art-card-container">
          <Img
            className="image-card"
            fluid={data.imageOne.childImageSharp.fluid} 
          />      
            <div className="overlay-card">
              <div className="text-card">
                <div className="text-card-title">PolyArch</div>
                <p>
                  Generative 3d forms{" "}
                </p>
                <div className="text-card-tags">Processing, Hemesh, SunFlow</div>
              </div>
            </div>     
        </div>
        </Link>

        </div>

    </Layout>
  )
}

export default Process
